import * as commonFields from "./common-fields";
import type { BaseEquipAreaViewDto } from "@ckweb/ckfetch/connectables/equipmentAreaManagement";

type EquipAreaDataItem = Omit<
  BaseEquipAreaViewDto,
  "manufactureVendorNumber"
> & {
  number?: number;
};

export const equipmentAreaSchema: $ck.z.ZodType<EquipAreaDataItem> =
  $ck.z.object({
    number: commonFields.optionalNumberField(),
    name: commonFields.requiredStringField(),
    isAsset: commonFields.booleanField(),
    active: commonFields.booleanField(),
    lineNumber: commonFields.requiredNumericListItemField(),
    lineName: commonFields.requiredStringListItemField(),
    dayNumber: commonFields.requiredNumberField(),
    location: commonFields.stringOrEmptyField(),
    workGroupNumber: commonFields.requiredNumericListItemField(),
    workGroupName: commonFields.requiredStringListItemField(),
    changeoverLevel: commonFields.requiredNumericListItemField(),
    critical: commonFields.booleanField(),
    hasNoTasks: commonFields.booleanField(),
    corpEquipNum: commonFields.stringOrEmptyField(),
    includeInInspections: commonFields.booleanField(),
    workpackDayNumber: commonFields.requiredNumericListItemField(),
    includeInWo: commonFields.booleanField(),
    corporateCategoryNumber: commonFields.requiredNumericListItemField(),
    corporateCategoryName: commonFields.requiredStringListItemField(),
    taskHeight: commonFields.requiredNumericListItemField(),
    mobileGenerateSheet: commonFields.booleanField(),
    noTaskForward: commonFields.booleanField(),
    corporateReportUse: commonFields.requiredNumberField(),
    corporateLock: commonFields.booleanField(),
    isNoDelete: commonFields.booleanField(),
    model: commonFields.requiredStringListItemField(),
  });

export type EquipmentAreaSchema = $ck.z.TypeOf<typeof equipmentAreaSchema>;
